export default function generateEvaluationTitle(form, formValues, t) {
	let title = '';
	if (form.titlefields) {
		form.titlefields.forEach((titlefield) => {
			if (formValues[titlefield] && formValues[titlefield] !== '') {
				if (title === '') {
					title = formValues[titlefield].label ?? formValues[titlefield];
				} else {
					title = `${title} - ${formValues[titlefield].label ?? formValues[titlefield]}`;
				}
			}
		});
	}

	if (title === '') {
		title = t('eval_app_evaluation');
	}

	return title;
}
